<div class="notfound-container">
  <div class="notfound-content">
    <!-- 404 Visual -->
    <div class="notfound-visual">
      <div class="notfound-number">404</div>
      <div class="notfound-icon">
        <i [class]="icon" style="font-size: 4rem; color: #94a3b8;"></i>
      </div>
    </div>

    <!-- Error Code Display (if specific error) -->
    <div class="notfound-code" *ngIf="errorCode">
      <span class="code-label">Code:</span>
      <span class="code-value">{{ errorCode }}</span>
    </div>

    <!-- Main Message -->
    <div class="notfound-message">
      <h1 class="notfound-title">{{ title }}</h1>
      <p class="notfound-description" [innerHTML]="safeDescription">
      </p>
    </div>

    <!-- Action Buttons -->
    <div class="notfound-actions">
      <!-- Specific Actions (if any) -->
      <ng-container *ngFor="let action of specificActions">
        <p-button
          [label]="action.label"
          [icon]="action.icon"
          (onClick)="action.action()"
          class="p-button-primary">
        </p-button>
      </ng-container>

      <!-- Standard Actions -->
      <p-button
        label="Go Home"
        icon="pi pi-home"
        (onClick)="goHome()"
        class="p-button-primary">
      </p-button>
    </div>

    <!-- Additional Help -->
    <div class="notfound-help">
      <p class="help-text">
        <i class="pi pi-info-circle"></i>
        If you believe this is an error, please contact the system administrator
      </p>
    </div>
  </div>
</div>
